import { createFinishStepContent } from '../FinishStepContent';
import { closeSidebarPanel, openAnalyticsSubmenu } from '../sidebarHelpers';

const exploreUserBaseTab = (baseUrl, navigate, user) => {
  return {
    id: 'exploreUserBaseTab',
    title: 'Explore User Base Tab',
    steps: [
      {
        selector: `[data-tour="analyticsLink"]`,
        content: <p>Click on the "Analytics" section in the navigation.</p>,
      },
      {
        selector: `[data-tour="dashboardLink"]`,
        content: <p>Click on the "Dashboard" in the navigation.</p>,
        actionBefore: () => openAnalyticsSubmenu('[data-tour="dashboardLink"]'),
      },
      {
        actionBefore: () => {
          closeSidebarPanel();
          navigate(`${baseUrl}/analytics`, true);
        },
        selector: '[data-tour="userBaseTab"]',
        content: (
          <>
            <p>In this tab, you can keep track of the ratio of subscribed and unsubscribed users.</p>
            <p>Click on the "User Base" tab.</p>
          </>
        ),
      },
      {
        actionBefore: () => navigate(`${baseUrl}/analytics?mainTab=userBase`, true),
        selector: '[data-tour="userBaseTopStats"]',
        content: <p>In this section, you can see the totals for each stat and a comparison to the previous period.</p>,
      },
      {
        selector: '[data-tour="userBaseSubscribesAndUnsubscribes"]',
        content: (
          <p>
            This dynamic can give you information on whether your email campaigns are too aggressive and a lot of people
            unsubscribe and whether you're growing your audience as best as possible.
          </p>
        ),
      },
      {
        actionBefore: () => navigate(`${baseUrl}/guide`, true),
        selector: '[data-tour="userGuideHeading"]',
        content: createFinishStepContent(),
      },
    ],
    isComplete: !!user.userActions.find((a) => a.action === 'taskCompleted' && a.context.task === 'exploreUserBaseTab'),
  };
};

export default exploreUserBaseTab;
